export default __webpack_public_path__ + "static/media/Sun.770c795f.svg";